export default [
    {
        "type": "event",
        "date": "2020/01/03",
        "title": "ホロライブ4期生としてデビュー",
        "description": "",
        "image": "",
        "param": "",
        "link": "",
    },
    {
        "type": "release",
        "title": "Palette",
        "description": "Tokoyami Towa 1st original song.",
        "param": "s=Ud73fm4Uoq0",
    },
    {
        "type": "release",
        "title": "マドロミ",
        "description": "",
        "param": "s=23nEnPOXLEk",
    },
    {
        "type": "release",
        "title": "Scream",
        "description": "Tokoyami Towa 1st EP.",
        "param": "t=Scream",
        "badge": "1st EP",
    },
    {
        "type": "release",
        "title": "Aster",
        "description": "Tokoyami Towa 1st Album.",
        "param": "t=Aster",
        "badge": "1st Album",
    },
    {
        "type": "live",
        "date": "2023/10/13",
        "title": "Break Your XXX",
        "description": "Tokoyami Towa 1st solo Live at TACHIKAWA STAGE GARDEN.",
        "image": "https://hololive.hololivepro.com/wp-content/uploads/2023/07/230723_sub1.png",
        "param": "t=breakyourxxx",
        "link": "https://towa1stlive.hololivepro.com/",
        "badge": "1st Live",
    },
    {
        "type": "release",
        "title": "S.T.Y.",
        "description": "",
        "param": "t=S.T.Y.",
        "badge": "1st Single",
    },
    {
        "type": "release",
        "title": "My Abyss",
        "description": "",
        "param": "s=PMgjFPqXZV4",
    },
    {
        "type": "release",
        "title": "バズビバザヴ",
        "description": "",
        "param": "s=uxjcPq0Y_IA",
    },
    {
        "type": "release",
        "title": "ChewyChewy",
        "description": "",
        "param": "s=din8MpMohyg",
    },
    {
        "type": "release",
        "title": "SHIN",
        "description": "Tokoyami Towa 2nd Album.",
        "param": "t=SHIN",
        "badge": "2nd Album",
    },
    {
        "type": "live",
        "date": "2025/10/29",
        "title": "SHINier",
        "description": "Tokoyami Towa 2nd Live at ARIAKE ARENA.",
        "image": "https://hololive.hololivepro.com/wp-content/uploads/2025/08/SHINier-KV-2048x1152.webp",
        "param": "t=shinier",
        "link": "https://shinier.hololivepro.com/",
        "badge": "2nd Live",
    },
    {
        "type": "release",
        "title": "シルベ",
        "description": "TVアニメ「勇者パーティを追い出された器用貧乏」OPテーマ",
        "param": "t=シルベ",
        "badge": "2nd Single",
    },
    {
        "type": "release",
        "title": "ANEMONE",
        "description": "",
        "param": "s=G3J06ircgMA",
    },
    {
        "type": "release",
        "title": "ライメイ",
        "description": "",
        "param": "s=TfOx00AOfKo",
    },
    {
        "type": "release",
        "title": "サンビタリア",
        "description": "",
        "param": "s=ScTHsLH_0js",
    },
    {
        "type": "release",
        "title": "U.F.O. - U Feel Overjoyed! -",
        "description": "日清焼そばU.F.O. コラボ楽曲",
        "param": "s=HBmss54l5zc",
    },
    {
        "type": "release",
        "title": "Over Time",
        "description": "",
        "param": "s=5ArDbvfds9k",
        "badge": "ORIO"
    },
    {
        "type": "release",
        "title": "Queen of the Night",
        "description": "Mythmash cheMythtry",
        "param": "s=X2KpK47AacY",
    },
    {
        "type": "release",
        "title": "君と明かした夜",
        "description": "『灰仭巫覡(カイジンフゲキ)』イメージソング",
        "param": "s=3nfkl8_tWM0",
    },
    {
        "type": "event",
        "date": "2020/04/17",
        "title": "YouTube チャンネル登録者数10万人突破",
        "description": "",
        "image": "",
        "param": "",
        "link": "",
    },
    {
        "type": "event",
        "date": "2021/02/08",
        "title": "YouTube チャンネル登録者数50万人突破",
        "description": "",
        "image": "",
        "param": "",
        "link": "",
    },
    {
        "type": "event",
        "date": "2022/04/03",
        "title": "YouTube チャンネル登録者数100万人突破",
        "description": "",
        "image": "",
        "param": "",
        "link": "",
    },
    {
        "type": "event",
        "date": "2025/02/25",
        "title": "YouTube チャンネル登録者数150万人突破",
        "description": "【歌枠 / Singing Stream】１５０万人感謝の歌！重大告知あり🎉【常闇トワ/ホロライブ】",
        "image": "",
        "param": "",
        "link": "https://www.youtube.com/watch?v=nlsWCIhpZzc",
    },
    {
        "type": "event",
        "date": "2020/07/26",
        "title": "常闇トワ 3Dモデルお披露目",
        "description": "【#常闇トワ3D】常闇トワ様3Dお披露目！悪魔になるための一歩♥【#JointhefutureJP】",
        "image": "",
        "param": "",
        "link": "https://www.youtube.com/watch?v=UlemRwXYWHg",
    },
    {
        "type": "event",
        "date": "2026/01/03",
        "title": "常闇トワ 活動6周年",
        "description": "【 #常闇トワ6周年記念LIVE 】ROCK Festa !!!【 3DLIVE 】",
        "image": "",
        "param": "",
        "link": "https://www.youtube.com/watch?v=pmWH-wAJYRE",
    },
    {
        "type": "event",
        "date": "2025/01/03",
        "title": "常闇トワ 活動5周年",
        "description": "",
        "image": "",
        "param": "",
        "link": "",
    },
    {
        "type": "event",
        "date": "2025/01/05",
        "title": "ホロライブ4期生 活動5周年ライブ",
        "description": "【3D LIVE】1 day 4 colors【#ホロ4期生ライブ2025】",
        "image": "",
        "param": "",
        "link": "https://www.youtube.com/watch?v=H8A2CZiyc_E",
    },
    {
        "type": "event",
        "date": "2026/08/08",
        "title": "常闇トワ 誕生日2026",
        "description": "【 #常闇トワ生誕祭2026 】告知あり！新衣装お披露目ミニライブ🎶【 3DLIVE 】",
        "image": "",
        "param": "",
        "link": "https://www.youtube.com/watch?v=07qx3PL4b3U",
    },
    {
        "type": "event",
        "date": "2025/08/08",
        "title": "常闇トワ 誕生日2025",
        "description": "【 #常闇トワ生誕祭2025 】超重大発表あり！Sincerely,Towa【 3DLIVE 】",
        "image": "",
        "param": "",
        "link": "https://www.youtube.com/watch?v=I4FbpwMb78U",
    },
    {
        "type": "event",
        "date": "2024/08/08",
        "title": "常闇トワ 誕生日2024",
        "description": "【#常闇トワ生誕祭2024】ｰ COLORFUL ｰ【3DLIVE】",
        "image": "",
        "param": "",
        "link": "https://www.youtube.com/watch?v=C-QdqYjdArM",
    },
    {
        "type": "event",
        "date": "2022/01/03",
        "title": "常闇トワ 活動2周年",
        "description": "【3DLIVE】この叫びを届けるためにｰScreamｰ【#常闇トワ2周年記念】",
        "image": "",
        "param": "",
        "link": "https://www.youtube.com/watch?v=YsvEWEEUWa8",
    },
    {
        "type": "event",
        "date": "2022/08/08",
        "title": "常闇トワ 誕生日2022",
        "description": "【#常闇トワ生誕祭2022】MIX -私の存在証明- 【3DLIVE】",
        "image": "",
        "param": "",
        "link": "https://www.youtube.com/watch?v=KyURvb-eIU8",
    },
    {
        "type": "event",
        "date": "2021/08/08",
        "title": "常闇トワ 誕生日2021",
        "description": "【#常闇トワ生誕祭2021】ゲストもいっぱい！楽しんじゃお！✨【3DLIVE】",
        "image": "",
        "param": "",
        "link": "https://www.youtube.com/watch?v=NuOJhtBC7R4",
    },
    {
        "type": "event",
        "date": "2023/01/03",
        "title": "常闇トワ 活動3周年",
        "description": "【#常闇トワ3周年記念LIVE】MIX2 - 私の居場所 - 【3DLIVE】",
        "image": "",
        "param": "",
        "link": "https://www.youtube.com/watch?v=knb_mosTUvo",
    },
    {
        "type": "event",
        "date": "2021/04/17",
        "title": "常闇トワ 活動1周年",
        "description": "【3D】生演奏！？楽しんだもん勝ちのBANDLIVE！【#常闇トワ1周年記念】",
        "image": "",
        "param": "",
        "link": "https://www.youtube.com/watch?v=TjhOZn1vNW4",
    },
    {
        "type": "event",
        "date": "2021/09/11",
        "title": "#マドロミライブ Presented by SQUARE ENIX",
        "description": "#マドロミライブ Presented by SQUARE ENIX",
        "image": "",
        "param": "",
        "link": "https://www.youtube.com/watch?v=gNziHtkliOo",
    },
    {
        "type": "release",
        "title": "#ウチらしか勝たん",
        "description": "ねねねトワワオリジナル曲",
        "param": "s=oUd1hLK7p2I",
    },
    {
        "type": "release",
        "title": "SM4SH IT UP",
        "description": "",
        "param": "s=lmBkWOkBCBA",
    },
    {
        "type": "release",
        "title": "Rewrite the Answer",
        "description": "TVアニメ『追放された転生重騎士はゲーム知識で無双する』OPテーマ",
        "param": "s=yOI1qMpfuRw",
    },
]